import React from "react";
import IconContainer from "@/components/ui/icon-container";
import {
  ProgressIndicator,
  ProgressIndicatorCompleted,
  ProgressIndicatorEmpty
} from "@dreamhub/designsystem/icons";

interface Props {
  isCurrent: boolean;
  isPrevious: boolean;
}

const StageProgressIcon: React.FC<Props> = ({ isCurrent, isPrevious }) => {
  if (isCurrent || isPrevious) {
    return (
      <IconContainer size="5" color={isCurrent ? "primary" : "secondary"}>
        {isCurrent ? <ProgressIndicator /> : <ProgressIndicatorCompleted />}
      </IconContainer>
    );
  }
  return (
    <IconContainer size="5" color="tertiary">
      <ProgressIndicatorEmpty />
    </IconContainer>
  );
};

export default StageProgressIcon;
